(function(){
"use strict";
/* il foglio del marchio va caricato insieme agli altri */
try{
 var base=document.querySelector('link[href*="dema-younited.css"]');
 if(base && !document.querySelector('link[href*="dema-younited-logo.css"]')){
  var l=document.createElement("link");
  l.rel="stylesheet";
  l.href=base.href.replace("dema-younited.css","dema-younited-logo.css");
  document.head.appendChild(l);
 }
}catch(e){}

var range=document.getElementById("dyRange");
if(!range)return;

var impo=document.getElementById("dyImporto");
var rata=document.getElementById("dyRata");
var dett=document.getElementById("dyDett");
var bottoni=document.querySelectorAll(".dyou .d");
var mesi=36;
var TAN=0.1228;

function euro(n){return "\u20ac"+Number(n).toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2})}
function calcola(tot,n){var i=TAN/12;return tot*i/(1-Math.pow(1+i,-n))}

function disegna(){
 var tot=Number(range.value);
 impo.textContent=tot.toLocaleString("it-IT");
 var p=((tot-range.min)/(range.max-range.min))*100;
 range.style.setProperty("--p",p+"%");
 rata.textContent=euro(calcola(tot,mesi));
 dett.innerHTML="in "+mesi+" rate \u00b7 TAN fisso 12,28% \u00b7 TAEG 12,99%";
}

range.addEventListener("input",disegna);
for(var i=0;i<bottoni.length;i++){
 bottoni[i].addEventListener("click",function(){
  for(var j=0;j<bottoni.length;j++)bottoni[j].classList.remove("on");
  this.classList.add("on");
  mesi=Number(this.getAttribute("data-mesi"))||36;
  disegna();
 });
}
disegna();
})();
